import React, { useState } from 'react'
import { Button, Flex, Heading, Link, useModal } from '@pancakeswap/uikit'
import { useRouter } from 'next/router'
import styled from 'styled-components'
import { useTranslation } from '@pancakeswap/localization'
import Page, { PageMeta } from 'components/Layout/Page'
import PageHeader from 'components/PageHeader'
import Container from 'components/Layout/Container'
import IfoProvider from './contexts/IfoContext'

const StyledContainer = styled(Container)`
  padding-left: 8px;
  padding-right: 8px;

  ${({ theme }) => theme.mediaQueries.sm} {
    padding-left: 24px;
    padding-right: 24px;
  }
`

export const CandyLockLayout = ({ children }) => {
  const { t } = useTranslation()
  const router = useRouter()

  return (
    <IfoProvider>
      <PageHeader>
        <Flex
          justifyContent="space-between"
          flexDirection={['column', null, null, 'row']}
          alignItems="center"
          style={{ gap: '8px' }}
        >
          <Flex flex="1" flexDirection="column" mr={['8px', 0]}>
            <Heading as="h1" scale="xxl" color="secondary" mb="24px">
              {t('Candy Lock')}
            </Heading>
            <Heading scale="lg" color="text">
              {t('Lock candy token and nft to earn long-term rewards.')}
            </Heading>
          </Flex>
          {/* {
            router.route === '/candylock/create' ? (
              <Button variant='secondary' scale='md' as={Link} href='/candylock'>Back to Locks</Button>
            ) : (
              <Button variant='secondary' scale='md' as={Link} href='/candylock/create'>Create New Lock</Button>
            )
          } */}
        </Flex>
      </PageHeader>
      <Page>
        <StyledContainer>{children}</StyledContainer>
      </Page>
    </IfoProvider>
  )
}

export const CandyLockV2Layout = ({ children }) => {
  const { t } = useTranslation()
  const router = useRouter()

  return (
    <IfoProvider>
      <PageHeader>
        <Flex
          justifyContent="space-between"
          flexDirection={['column', null, null, 'row']}
          alignItems="center"
          style={{ gap: '8px' }}
        >
          <Flex flex="1" flexDirection="column" mr={['8px', 0]}>
            <Heading as="h1" scale="xxl" color="secondary" mb="24px">
              {t('Candy Lock V2')}
            </Heading>
            <Heading scale="lg" color="text">
              {t('Lock candy token and nft to earn long-term rewards.')}
            </Heading>
          </Flex>
          <Flex flexDirection="column" style={{ gap: '6px' }}>
            <Button style={{ width: '100%' }} variant="secondary" scale="md" as={Link} href="/candylock/v2/market">
              Purchase Lock
            </Button>
          </Flex>
        </Flex>
      </PageHeader>
      <Page>
        <StyledContainer>{children}</StyledContainer>
      </Page>
    </IfoProvider>
  )
}

export const CandyLockV2MarketLayout = ({ children }) => {
  const { t } = useTranslation()
  const router = useRouter()

  return (
    <IfoProvider>
      <PageHeader>
        <Flex
          justifyContent="space-between"
          flexDirection={['column', null, null, 'row']}
          alignItems="center"
          style={{ gap: '8px' }}
        >
          <Flex flex="1" flexDirection="column" mr={['8px', 0]}>
            <Heading as="h1" scale="xxl" color="secondary" mb="24px">
              {t('Candy Lock V2')}
            </Heading>
            <Heading scale="lg" color="text">
              {t('Buy the listed lock and earn long-term rewards.')}
            </Heading>
          </Flex>
          <Flex flexDirection="column" style={{ gap: '6px' }}>
            <Button style={{ width: '100%' }} variant="secondary" scale="md" as={Link} href="/candylock/v2">
              Back to Locks
            </Button>
          </Flex>
        </Flex>
      </PageHeader>
      <Page>
        <StyledContainer>{children}</StyledContainer>
      </Page>
    </IfoProvider>
  )
}

export const CandyLockV3Layout = ({ children }) => {
  const { t } = useTranslation()
  const router = useRouter()

  return (
    <IfoProvider>
      <PageHeader>
        <Flex
          justifyContent="space-between"
          flexDirection={['column', null, null, 'row']}
          alignItems="center"
          style={{ gap: '8px' }}
        >
          <Flex flex="1" flexDirection="column" mr={['8px', 0]}>
            <Heading as="h1" scale="xxl" color="secondary" mb="24px">
              {t('Candy Lock V3')}
            </Heading>
            <Heading scale="lg" color="text">
              {t('Lock candy token and nft to earn long-term rewards.')}
            </Heading>
          </Flex>
          <Flex flexDirection="column" style={{ gap: '6px' }}>
            {router.route === '/candylock/v3/create' ? (
              <Button variant="secondary" scale="md" as={Link} href="/candylock/v3">
                Back to Locks
              </Button>
            ) : (
              <Button variant="secondary" scale="md" as={Link} href="/candylock/v3/create">
                Create New Lock
              </Button>
            )}
            <Button style={{ width: '100%' }} variant="secondary" scale="md" as={Link} href="/candylock/v3/market">
              Purchase Lock
            </Button>
          </Flex>
        </Flex>
      </PageHeader>
      <Page>
        <StyledContainer>{children}</StyledContainer>
      </Page>
    </IfoProvider>
  )
}

export const CandyLockV3MarketLayout = ({ children }) => {
  const { t } = useTranslation()
  const router = useRouter()

  return (
    <IfoProvider>
      <PageHeader>
        <Flex
          justifyContent="space-between"
          flexDirection={['column', null, null, 'row']}
          alignItems="center"
          style={{ gap: '8px' }}
        >
          <Flex flex="1" flexDirection="column" mr={['8px', 0]}>
            <Heading as="h1" scale="xxl" color="secondary" mb="24px">
              {t('Candy Lock V3')}
            </Heading>
            <Heading scale="lg" color="text">
              {t('Buy the listed lock and earn long-term rewards.')}
            </Heading>
          </Flex>
          <Flex flexDirection="column" style={{ gap: '6px' }}>
            <Button variant="secondary" scale="md" as={Link} href="/candylock/v3/create">
              Create New Lock
            </Button>
            <Button style={{ width: '100%' }} variant="secondary" scale="md" as={Link} href="/candylock/v3">
              Back to Locks
            </Button>
          </Flex>
        </Flex>
      </PageHeader>
      <Page>
        <StyledContainer>{children}</StyledContainer>
      </Page>
    </IfoProvider>
  )
}
